import { Component, Input, ViewChild, ElementRef, AfterViewInit } from "@angular/core";
import Splide, { Options } from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import { IPictureData } from "../picture/picture.component";

@Component({
  selector: "app-autoscroll-image-carousel",
  templateUrl: "./autoscroll-image-carousel.component.html",
  styleUrls: ["./autoscroll-image-carousel.component.less"],
})
export class AutoscrollImageCarouselComponent implements AfterViewInit {
  @Input() imageList: IPictureData[];
  @Input() grayscaleImages: boolean;
  @Input() direction: 'ltr' | 'rtl' | 'ttb' = 'ltr';
  @ViewChild("splideRef", { static: false }) splideRef!: ElementRef;

  private splideInstance: any;

  ngAfterViewInit() {
    if (!this.splideInstance && this.splideRef) {
      setTimeout(() => this.mountSlider());
    }
  }

  mountSlider() {
    const options = {
      clones: 5,
      gap: "16px",
      type: "loop",
      drag: "free",
      arrows: false,
      focus: "center",
      pagination: false,
      direction: this.direction,

      autoScroll: {
        speed: 1,
        pauseOnHover: true,
      },

      breakpoints: {
        1024: {
          perPage: 4,
        },
        640: {
          gap: "8px",
        },
        540: {
          perPage: 3,
        },
      },
    };

    this.splideInstance = new Splide(
      this.splideRef.nativeElement,
      options as Options
    );
    this.splideInstance.mount({ AutoScroll });
  }

  ngOnDestroy() {
    if (this.splideInstance) {
      this.splideInstance.destroy();
    }
  }
}
